export const badgeStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  px: 1,
  backgroundColor: ({ palette }) => palette.background.secondary,
  borderRadius: '12px',
};

export const labelContainerStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
};

export const radioStyles = {
  padding: 0,
  pointerEvents: 'none',
  '& .MuiSvgIcon-root': {
    fontSize: 16,
  },
};
